import { ClipboardCheck } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { Skeleton } from "@/components/ui/skeleton";
import { usePartnerOnboarding } from "../use-partner-onboarding";
import { PartnerOnboardingItem } from "./partner-onboarding-item";

// Phase 7 sub-bucket 8 — port of /app/portal/onboarding/page.tsx.
// Reuses Phase 6 bucket 3 hook `usePartnerOnboarding()` — the GET already
// filters to assigned_to_partner=true rows scoped to session.partnerId
// (preview-as honored). Progress percentage derived in-component; no
// server-side aggregation needed.

export function OnboardingPage() {
  const query = usePartnerOnboarding();
  const tasks = query.data ?? [];

  const total = tasks.length;
  const done = tasks.filter((t) => t.status === "completed").length;
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;

  return (
    <div>
      <header className="mb-7">
        <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
          Onboarding
        </p>
        <h1 className="mt-1 font-display text-3xl font-semibold tracking-tight">
          Onboarding
        </h1>
        <p className="mt-1 max-w-2xl text-sm text-muted-foreground">
          Complete these steps to get the partnership rolling.
        </p>
      </header>

      {query.isLoading ? (
        <div className="space-y-3">
          <Skeleton className="h-24 w-full rounded-xl" />
          <Skeleton className="h-16 w-full rounded-xl" />
          <Skeleton className="h-16 w-full rounded-xl" />
          <Skeleton className="h-16 w-full rounded-xl" />
        </div>
      ) : total > 0 ? (
        <>
          <div className="mb-6 rounded-xl border bg-card p-5">
            <div className="mb-3 flex items-center justify-between">
              <p className="text-sm font-medium">Your progress</p>
              <span className="font-display text-xl font-semibold tabular-nums">
                {pct}%
              </span>
            </div>
            <Progress value={pct} />
            <p className="mt-2 text-xs text-muted-foreground">
              {done} of {total} complete
            </p>
          </div>

          <ul className="space-y-2">
            {tasks.map((t) => (
              <PartnerOnboardingItem key={t.id} task={t} />
            ))}
          </ul>
        </>
      ) : (
        <div className="flex flex-col items-center justify-center gap-2 rounded-xl border border-dashed bg-card px-6 py-14 text-center">
          <ClipboardCheck className="h-6 w-6 text-muted-foreground" />
          <h3 className="font-display text-base font-semibold tracking-tight">
            No onboarding tasks yet
          </h3>
          <p className="max-w-sm text-sm text-muted-foreground">
            Once Bookboost sets up your onboarding plan, your tasks will appear here.
          </p>
        </div>
      )}
    </div>
  );
}
